<template>
  <div class="box">
    <letter-commitment :type="type"></letter-commitment>
  </div>
</template>

<script>
import letterCommitment from "../../components/common/letterCommitment";
export default {
  name: "",
  components: { letterCommitment },
  props: {},
  data() {
    return {
    	type:1,
    };
  },
  computed: {},
  watch: {},
  created() {
  	if(this.$store.state.region=='5'){
  		this.type=4
  	}
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;
}
</style>
